/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XImg from './XImg';
export default {
  name: 'ImgItem',
  components: {
    XImg: XImg
  },
  props: {
    imgSrc: String,
    imgWidth: String,
    imgHeight: String,
    margin: String,
    direction: {
      type: String,
      "default": 'row'
    },
    border: {
      type: Boolean,
      "default": false
    },
    // top和bottom是否紧挨着
    next: {
      type: Boolean,
      "default": false
    },
    priceShow: {
      type: String,
      "default": ''
    },
    defaultImgSrc: String,
    invalidStr: String,
    invalid: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    var marginStyle = this.direction === 'row' ? {
      'margin-right': this.margin
    } : {
      'margin-bottom': this.margin
    };
    var styleObject = Object.assign({}, marginStyle);
    return {
      styleObject: styleObject
    };
  },
  created: function created() {}
};